import { ElMessage } from 'element-plus'
import { getAuthToken, handleUnauthorized } from './auth'

const normalizeHeaders = (headers = {}) => {
  if (headers instanceof Headers) {
    return headers
  }

  return new Headers(headers)
}

export const rawRequest = async (url, options = {}) => {
  const {
    method = 'GET',
    headers,
    body,
    auth = true,
    onUnauthorized
  } = options

  const requestHeaders = normalizeHeaders(headers)
  const token = getAuthToken()
  const isFormData = body instanceof FormData
  const hasJsonBody = body && !isFormData && typeof body === 'object'

  if (auth && token) {
    requestHeaders.set('Authorization', `Bearer ${token}`)
  }

  if (hasJsonBody) {
    requestHeaders.set('Content-Type', 'application/json')
  }

  const response = await fetch(url, {
    method,
    headers: requestHeaders,
    body: hasJsonBody ? JSON.stringify(body) : body
  })

  if (response.status === 401) {
    if (typeof onUnauthorized === 'function') {
      onUnauthorized(response)
    } else {
      handleUnauthorized()
    }
  }

  return response
}

export const request = async (url, options = {}) => {
  const {
    method = 'GET',
    showSuccessMessage = true
  } = options

  const response = await rawRequest(url, options)

  const contentType = response.headers.get('content-type') || ''
  const isJson = contentType.includes('application/json')
  const result = isJson ? await response.json() : await response.text()

  if (!response.ok) {
    const message = isJson ? result?.msg : result
    throw new Error(message || '请求失败')
  }

  if (!isJson) {
    return result
  }

  if (result?.code !== 0) {
    throw new Error(result?.msg || '请求失败')
  }

  if (showSuccessMessage && ['POST', 'PUT', 'DELETE'].includes(method.toUpperCase())) {
    ElMessage.success('请求成功！宝宝真棒！爱你宝宝！')
  }

  return result.data
}
